<app-wizard-stepper
  [steps]="steps"
  [current]="currentStep"
  [completed]="completedSteps"
  (stepClick)="goToStep($event)"
></app-wizard-stepper>
<ng-container
  *ngComponentOutlet="currentStepComponent; injector: currentStepInjector"
></ng-container>
